import {checkPassport} from '@router/guards/roleGuard'
export default {
  path: '/material',
  component: () => import('@views/Material/Index'),
  beforeEnter: checkPassport,
  children: [
    {
      path: 'index',
      name: 'material.index',
      component: () => import('@/components/Material/MaterialIndex')
    },
    // {
    //   path: 'mfd/:id/:stock',
    //   name: 'material.mfd',
    //   component: () => import('@/components/Material/MaterialMFDTable')
    // },
    {
      path: 'mfd/:id/:stock',
      name: 'material.mfd',
      component: () => import('@/components/Material/MaterialCreateMFD')
    },
    {
      path: 'mfdview/:id',
      name: 'material.mfd.view',
      component: () => import('@/components/Material/MaterialMFDTable'),
      props: { isView: true }
    },
    {
      path: 'searchmfd',
      name: 'searchmfd',
      component: () => import('@/components/SearchMFD/SearchMFD')
    },
    {
      path: 'searchinvoice',
      name: 'search.invoice',
      component: () => import('@/components/SearchInvoice/SearchInvoice')
    },
    {
      path: 'summary',
      name: 'material.summary',
      component: () => import('@/components/Material/MaterialIndex')
    },
    {
      path: 'mfd',
      name: 'material.mfdlist',
      component: () => import('@/components/Material/MaterialMFDStatus')
    },
    {
      path: 'invoice',
      name: 'material.invoice',
      component: () => import('@/components/Material/MaterialInvoiceStatus')
    },
    {
      path: 'contaminate/:id',
      name: 'material.contaminate',
      component: () => import('@/components/MaterialContaminate/MaterialContaminateForm')
    },
  ]
}
